import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessDeniedComponent } from './modules/shared/access-denied/access-denied.component';
import { NoInternetConnectionComponent } from './modules/shared/no-internet-connection/no-internet-connection.component';
import { OfflineLoginScreenComponent } from './modules/shared/offline-login-screen/offline-login-screen.component';
import { CountrySelectComponent } from './modules/shared/country-select/country-select.component';

const routes: Routes = [
  { path: '403/:noAccess', component: AccessDeniedComponent },
  { path: 'offline-login', component: OfflineLoginScreenComponent },
  { path: 'index.html', redirectTo: '' },
  { path: 'silentRenew.html', redirectTo: '' },
  { path: 'no-internet', component: NoInternetConnectionComponent },
  { path: 'country-select', component: CountrySelectComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
